<div>
  <div
    *ngIf="admin_custom_plano_stepper_index == 0"
    class="stepper-actions-container"
  >
    <button (click)="moveToLibrary()" class="back-button">
      <img
        style="margin-right: 1vw; width: 1vw"
        src="../../assets/back.svg"
        alt="back"
      />Go Back
    </button>
  </div>
  <div
    *ngIf="admin_custom_plano_stepper_index == 0"
    id="custom_planogram_container"
  >
    <div class="create_planogram_header">
      <div class="header">
        <em
          class="bi bi-person"
          style="font-size: 1.3rem; margin-right: 0.6vw"
        ></em>
        Admin
      </div>
      <div class="view-edit-text">
        <div>Edit Mode</div>
      </div>
    </div>
    <div>
      <div class="forms_npd_segment">
        <div
          id="planogram-create-form-group-container"
          [formGroup]="planogram_create_custom_planogram_form_group"
        >
          <div (click)="moveToCustomPlanogramLibrary()" class="view_library">
            <img src="../../assets/pin_icon.png" />
            <div>View Library</div>
          </div>

          <div class="form-group">
            <label
              style="font-weight: 550"
              for="planogram_name"
              [ngClass]="{
                'text-danger': (planogram_name_error | async) !== ''
              }"
              >Planogram Name
              <span
                *ngIf="isRequiredField('planogram_name')"
                class="astrick-class"
              >
                *</span
              >
            </label>
            <div style="display: flex; align-items: center">
              <input
                type="text"
                class="form-control"
                id="planogramname"
                formControlName="planogram_name"
                placeholder="Enter Planogram Name"
                required
                style="min-width: 100%; font-size: 0.9vw"
                [ngClass]="{
                  'is-invalid': (planogram_name_error | async) !== ''
                }"
                (blur)="onBlurPlanogramName()"
              />
              <em
                class="bi"
                [ngClass]="{
                  'bi-check-circle text-success':
                    planogram_create_custom_planogram_form_group.get(
                      'planogram_name'
                    )?.valid && (planogram_name_error | async) === '',
                  'bi-x-circle text-danger':
                    (planogram_name_error | async) !== ''
                }"
                style="margin: 0 5px"
              ></em>
            </div>

            <span
              *ngIf="(planogram_name_error | async) !== ''"
              class="error-message"
            >
              {{ planogram_name_error | async }}
            </span>
            <span
              class="error-message"
              *ngIf=" planogram_create_custom_planogram_form_group.controls['planogram_name'].errors?.['pattern']"
            >
              <span *ngIf="planogram_name_error | async">,</span>Special
              characters are not allowed.
            </span>
          </div>
          <div class="form-group dropdown">
            <label style="font-weight: 550" for="units"
              >Unit
              <span *ngIf="isRequiredField('units')" class="astrick-class">
                *</span
              >
            </label>
            <ng-template
              #subchanneltemp
              let-subchannellist="subchannellist"
              [ngTemplateOutlet]="subchanneltemp"
              [ngTemplateOutletContext]="{
                subchannellist: units
              }"
            >
              <mat-select
                class="custom-select d-block w-100"
                placeholder="Select Unit"
                formControlName="units"
                disableOptionCentering
                (selectionChange)="
                  clearSelectionOnValueChange($event, 'channel')
                "
              >
                <mat-option
                  style="font-size: 0.9vw; font-weight: 500"
                  *ngFor="let unit of subchannellist"
                  [value]="unit"
                >
                  <em
                    [ngClass]="{
                      'bi-check-circle-fill':
                        planogram_create_custom_planogram_form_group.controls[
                          'units'
                        ].value === unit,
                      'bi-circle':
                        planogram_create_custom_planogram_form_group.controls[
                          'units'
                        ].value !== unit
                    }"
                    class="bi"
                  ></em>
                  {{ unit }}
                </mat-option>
              </mat-select>
            </ng-template>
          </div>
          <div class="form-group dropdown">
            <label style="font-weight: 550" for="Channel"
              >Channel
              <span *ngIf="isRequiredField('channel')" class="astrick-class">
                *</span
              >
            </label>

            <mat-select
              class="custom-select d-block w-100"
              placeholder="Select Channel"
              formControlName="channel"
              disableOptionCentering
              (selectionChange)="handleChannelChange($event)"
              [ngClass]="{
                'disable-dropdown':
                  !units ||
                  planogram_create_custom_planogram_form_group.controls['units']
                    .value.length == 0
              }"
              [attr.disabled]="
                !planogram_create_custom_planogram_form_group.controls['units']
                  .value.length
              "
            >
              <mat-option
                style="font-size: 0.9vw; font-weight: 500"
                *ngFor="let channel of channels"
                [value]="channel"
              >
                <em
                  [ngClass]="{
                    'bi-check-circle-fill':
                      planogram_create_custom_planogram_form_group.controls[
                        'channel'
                      ].value === channel,
                    'bi-circle':
                      planogram_create_custom_planogram_form_group.controls[
                        'channel'
                      ].value !== channel
                  }"
                  class="bi"
                ></em>
                {{ channel }}
              </mat-option>
            </mat-select>
          </div>
          <div class="form-group dropdown">
            <label style="font-weight: 550" for="cooler_type"
              >Cooler
              <span
                *ngIf="isRequiredField('cooler_type')"
                class="astrick-class"
              >
                *</span
              >
            </label>

            <ng-template
              #segmenttemp
              let-segmentlist="segment_list"
              [ngTemplateOutlet]="segmenttemp"
              [ngTemplateOutletContext]="{
                segment_list: coolers
              }"
            >
              <mat-select
                class="custom-select d-block w-100"
                placeholder="Select Cooler"
                formControlName="cooler_type"
                disableOptionCentering
                [ngClass]="{
                  'disable-dropdown':
                    !channels ||
                    planogram_create_custom_planogram_form_group.controls[
                      'channel'
                    ].value.length == 0
                }"
                [attr.disabled]="
                  !channels ||
                  planogram_create_custom_planogram_form_group.controls[
                    'channel'
                  ].value.length == 0
                "
                value="planogram_create_custom_planogram_form_group.controls['cooler_type'].value"
                (selectionChange)="clearSelectedCoolerInfo()"
              >
                <mat-option
                  style="font-size: 0.9vw; font-weight: 500"
                  *ngFor="let cooler of segmentlist"
                  [value]="cooler"
                >
                  <em
                    [ngClass]="{
                      'bi-check-circle-fill':
                        planogram_create_custom_planogram_form_group.controls[
                          'cooler_type'
                        ].value === cooler,
                      'bi-circle':
                        planogram_create_custom_planogram_form_group.controls[
                          'cooler_type'
                        ].value !== cooler
                    }"
                    class="bi"
                  ></em>
                  {{ cooler }}
                </mat-option>
              </mat-select>
            </ng-template>
          </div>
        </div>
        <div *ngIf="temp_npd_data" class="npd_segment">
          <div class="npd_container">
            <div *ngFor="let npd of temp_npd_data.NPDs; let i = index">
              <div class="npd_card">
                <div
                  *ngIf="showToolTip(npd.product_name)"
                  [matTooltip]="npd.product_name"
                >
                  {{ truncateNPDName(npd.product_name) }}
                </div>
                <div *ngIf="!showToolTip(npd.product_name)">
                  {{ truncateNPDName(npd.product_name) }}
                </div>
                <div class="increment_decrement_container">
                  <button
                    class="minus"
                    (click)="decrement(i, npd.product_name)"
                  >
                    -
                  </button>
                  <input
                    style="width: 3vw; height: 4vh; font-size: 0.9vw"
                    [value]="npd_data_with_facings[i].facings"
                    type="text"
                    class="input-number npd_counter_value"
                  />
                  <button class="plus" (click)="increment(i, npd.product_name)">
                    +
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div style="padding: 0px 8vh">
            <div style="font-size: 0.9vw; font-weight: bold">
              *NEXT button will be activated on proper selection of number of
              NPDs
            </div>
            <div style="font-weight: bold; font-size: 0.9vw; margin-top: 5px">
              *Min.
              {{
                this.temp_npd_data.minimum_facings ||
                  this.temp_npd_data.min_facings
              }}
              facing per NPD will be allocated
            </div>
            <div style="font-size: 0.9vw; margin-top: 5px">
              {{ npds_max_message }}
            </div>
          </div>
          <button
            [disabled]="
              (planogram_name_error | async) !== '' ||
              planogram_create_custom_planogram_form_group.get('planogram_name')
                ?.value.length == 0 ||
              !isValidPlan
            "
            class="my-red-button create-plano-btn"
            (click)="createCustomPlanogram()"
          >
            Create Plano
          </button>
        </div>
        <div *ngIf="!temp_npd_data" class="npd_segment_skeleton">
          <div class="npd_container">
            <div *ngFor="let i of [1, 2, 3]">
              <div class="npd_card skeleton">
                {{ " " }}
                <div style="display: flex">
                  <button class="minus">-</button>
                  <input
                    [disabled]="true"
                    style="width: 3vw; height: 4vh; font-size: 0.9vw"
                    type="text"
                    class="input-number npd_counter_value"
                  />
                  <button class="plus">+</button>
                </div>
              </div>
            </div>
          </div>
          <div></div>
        </div>
      </div>
    </div>
  </div>
  <div
    *ngIf="admin_custom_plano_stepper_index == 1"
    class="stepper-actions-container"
  >
    <button (click)="goBack()" class="back-button">
      <img
        style="margin-right: 1vw; width: 1vw"
        src="../../assets/back.svg"
        alt="back"
      />Go Back
    </button>
    <div style="display: flex; gap: 20px; justify-content: center;align-items: center;">
      <div>*Click on reset to edit the planogram</div>
      <button mat-raised-button (click)="reset()">Reset</button>
      <button
        class="next"
        (click)="saveAndPublish()"
        mat-raised-button
        color="warn"
      >
        Save and Exit
      </button>
    </div>
  </div>
  <div>
    <app-planogram-new-builder
      [isReset]="isReset"
      [is_display]="admin_custom_plano_stepper_index == 1"
      [planogram_id]="planogram_id"
      (resetSkusInPlanogram)="resetPlanogram($event)"
      [planogram_details]="{
        cooler:
          planogram_create_custom_planogram_form_group.get('cooler_type')?.value
      }"
      [save]="save"
    ></app-planogram-new-builder>
  </div>
  <app-loader [is_show_loader]="(is_show_loader | async)!"></app-loader>
</div>
